/* This icon is used when creating a new list
It's not meant to display as a fallback for book lists, as their images are served via API */

const BooklistDefaultIcon = () => (
  <svg
    width="154"
    height="154"
    viewBox="0 0 154 154"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="154" height="154" rx="8" fill="#847F7C" />
    <g filter="url(#filter0_d)">
      <rect x="12" y="12" width="130" height="130" rx="4" fill="white" />
    </g>
    <path
      d="M94 130C94 132.209 92.2091 134 90 134L24 134C21.7909 134 20 132.209 20 130L20 24C20 21.7909 21.7909 20 24 20L90 20C92.2091 20 94 21.7909 94 24L94 130Z"
      fill="#EDEDED"
    />
    <path
      d="M134 72C134 74.2091 132.209 76 130 76L100 76C97.7909 76 96 74.2091 96 72L96 24C96 21.7909 97.7909 20 100 20L130 20C132.209 20 134 21.7909 134 24L134 72Z"
      fill="#EDEDED"
    />
    <g clipPath="url(#clip0)">
      <path
        d="M111.566 44.2578L110.561 44.8689L113.462 50.1611L114.467 49.55L111.566 44.2578Z"
        fill="white"
      />
      <path
        d="M108.379 47.165L107.799 48.2235L112.825 51.279L113.405 50.2206L108.379 47.165Z"
        fill="white"
      />
      <path d="M112.803 51.3611H107V52.5833H112.803V51.3611Z" fill="white" />
      <path d="M123.25 51.3611H117.446V52.5833H123.25V51.3611Z" fill="white" />
      <path
        d="M121.871 47.1658L116.845 50.2213L117.425 51.2797L122.451 48.2242L121.871 47.1658Z"
        fill="white"
      />
      <path
        d="M118.685 44.2581L115.783 49.5502L116.788 50.1613L119.69 44.8692L118.685 44.2581Z"
        fill="white"
      />
      <path
        d="M115.706 43.4167H114.545V49.5278H115.706V43.4167Z"
        fill="white"
      />
    </g>
    <path
      d="M134 130C134 132.209 132.209 134 130 134L100 134C97.7909 134 96 132.209 96 130L96 82C96 79.7909 97.7909 78 100 78L130 78C132.209 78 134 79.7909 134 82L134 130Z"
      fill="#EDEDED"
    />
    <g clipPath="url(#clip1)">
      <path
        d="M111.566 101.258L110.561 101.869L113.462 107.161L114.467 106.55L111.566 101.258Z"
        fill="white"
      />
      <path
        d="M108.379 104.165L107.799 105.223L112.825 108.279L113.405 107.221L108.379 104.165Z"
        fill="white"
      />
      <path d="M112.803 108.361H107V109.583H112.803V108.361Z" fill="white" />
      <path d="M123.25 108.361H117.446V109.583H123.25V108.361Z" fill="white" />
      <path
        d="M121.871 104.166L116.845 107.221L117.425 108.28L122.451 105.224L121.871 104.166Z"
        fill="white"
      />
      <path
        d="M118.685 101.258L115.783 106.55L116.788 107.161L119.69 101.869L118.685 101.258Z"
        fill="white"
      />
      <path
        d="M115.706 100.417H114.545V106.528H115.706V100.417Z"
        fill="white"
      />
    </g>
    <g clipPath="url(#clip2)">
      <path
        d="M52.3916 71.761L50.9844 72.6165L55.0468 80.0256L56.4541 79.17L52.3916 71.761Z"
        fill="white"
      />
      <path
        d="M47.9307 75.8311L47.1182 77.3129L54.1543 81.5906L54.9668 80.1088L47.9307 75.8311Z"
        fill="white"
      />
      <path d="M54.1249 81.7056H46V83.4167H54.1249V81.7056Z" fill="white" />
      <path d="M68.7499 81.7056H60.625V83.4167H68.7499V81.7056Z" fill="white" />
      <path
        d="M66.8194 75.832L59.7832 80.1098L60.5957 81.5916L67.6319 77.3138L66.8194 75.832Z"
        fill="white"
      />
      <path
        d="M62.3593 71.7612L58.2969 79.1703L59.7041 80.0258L63.7665 72.6168L62.3593 71.7612Z"
        fill="white"
      />
      <path
        d="M58.1875 70.5833H56.5625V79.1388H58.1875V70.5833Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="10"
        width="154"
        height="154"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="6" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect
          width="16.25"
          height="10"
          fill="white"
          transform="translate(107 43)"
        />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="16.25"
          height="10"
          fill="white"
          transform="translate(107 100)"
        />
      </clipPath>
      <clipPath id="clip2">
        <rect
          width="22.75"
          height="14"
          fill="white"
          transform="translate(46 70)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default BooklistDefaultIcon
